<script setup lang="ts">
defineOptions({
	name: "school.school-setup",
});
definePage({
	name: "school.school-setup",
	path: "/school/school-setup",
	redirect: "/school/school-setup/public-page-management",
});
</script>

<template>
	<router-view></router-view>
</template>
